module.exports = __webpack_public_path__ + "img/acOne.25452b79.jpg";